/* eslint-disable custom/relay-unused-fields-allow-connection */
/* eslint-disable relay/must-colocate-fragment-spreads */
import { graphql, useFragment, usePreloadedQuery } from "react-relay";

import { useCurrentUserQueryRef } from "./CurrentUserProvider";

import type { useCurrentUser_user$key } from "__generated__/useCurrentUser_user.graphql";
import type { useCurrentUserQuery } from "__generated__/useCurrentUserQuery.graphql";

const userFragment = graphql`
  fragment useCurrentUser_user on User {
    id
    organizationId
    organizationPermission
    ...useUserOverrides_user
  }
`;

export const userQuery = graphql`
  query useCurrentUserQuery @team(name: "cloud-security") {
    user {
      id
      ...useCurrentUser_user
      ...OrganizationSwitcher_user @arguments(count: 1)
    }
    ...useCloudEnvironmentSettings_query
  }
`;

export function useCurrentUser(user: useCurrentUser_user$key | null) {
  return useFragment(userFragment, user);
}

// Reads the current user from the preloaded query via CurrentUserContext.
// The query is loaded once at the root of the app (CurrentUserProvider) and all
// callsites are served from the relay cache without additional network requests.
// Will suspend if the query data is not yet available.
export function useCachedCurrentUser() {
  const queryRef = useCurrentUserQueryRef();
  const data = usePreloadedQuery<useCurrentUserQuery>(userQuery, queryRef);
  return useCurrentUser(data.user);
}
